export const WEBVIEW_ROUTES = {
  webviewDetail: `/webview`,
  webviewSearch: `/webview/search`,
  webviewSearchPreview: `/webview/search-preview`,

  webviewAthSearch: `/webview/audio-to-haptic/search`,
  webviewAthSearchPreview: `/webview/audio-to-haptic/search-preview`,
  webviewAthMy: `/webview/audio-to-haptic/my`,
};

export const PCP_WEBVIEW_ROUTES = {
  webviewDetail: `/webview-pcp`,
  webviewSearch: `/webview-pcp/search`,
  webviewHome: `/webview-pcp/home`,
};
